<template>
  <div class="pingtai_module">
    <el-row>
      <el-col :span="4">
        &nbsp;
      </el-col>
      <el-col :span="5" v-for="(item,index) in pingtaiArr" :key="index" @click="flyToTheOne(index)" class="pingtai_item">
        <a :href="item.url" target="_blank">
          <img :src="item.path" alt="" class="img_main">
          <div class="subTitle pingtai_text">{{item.name}}</div>
        </a>
      </el-col>
      <el-col :span="4">
        &nbsp;
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { pingtaiList } from '@/api/frontApi/frontHome';
export default {
  data() {
    return {
      pingtaiArr: [
        {
          path: '../../../../static/img/pingtai/pingtai1.png',
          name: 'An Intelligent O&M Platform',
          url: 'http://yg.chiaic.com'
        },
        {
          path: '../../../../static/img/pingtai/pingtai2.png',
          name: 'Intelligent Agriculture Platform',
          url: 'http://zhny.chiaic.com'
        },
        {
          path: '../../../../static/img/pingtai/pingtai3.png',
          name: 'A Modern Agriculture Supervision Platform',
          url: 'http://xdny.chiaic.com'
        }
      ],
      pingtaiCup: []
    };
  },
  created() {
    // this.getPingtaiList();
  },
  methods: {
    getPingtaiList() {
      pingtaiList().then(res => {
        res.data.forEach(item => {
          let temp = {
            path: '',
            name: '',
            img: ''
          };
          temp.path = item.comBody;
          temp.name = item.comName;
          temp.img = item.comImg;
          this.pingtaiArr.push(temp);
        });
      });
    },
    flyToTheOne(index) {
      switch (index) {
        case 1:
          window.open('');
          break;
        case 2:
          window.open(
            'https://blog.csdn.net/qq_43639296/article/details/93895513'
          );
          break;
        case 3:
          window.open(
            'https://blog.csdn.net/qq_43639296/article/details/93895513'
          );
          break;
      }
    }
  }
};
</script>
<style scoped>
.pingtai_module {
  padding: 20px 0;
  width: 100%;
  margin: 0 auto;
  text-align: center;
}
.pingtai_item {
  cursor: pointer;
  text-align: center;
  padding: 0 auto;
  margin-right: 10px;
}
.pingtai_text {
  color: #00697f;
}

.img_main {
  border: 1px double #f3f3f3;
}
.img_main:hover {
  border: 1px solid #f3f3f3;
  border-radius: 80px;
  box-shadow: 0 0 20px #00697f;
}
</style>



// WEBPACK FOOTER //
// src/pages/enViews/home/pingtai.vue